import LeaseTerms from './LeaseTerms_v1';
import type { Lease, Section } from '../../../models/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  lease: Lease;
};

function LeaseTerms_v3(props: Props): JSX.Element {
  return <LeaseTerms {...props} />;
}

LeaseTerms_v3.description = 'Lease Terms for Colorado.';

export default LeaseTerms_v3;
